module.exports = __webpack_public_path__ + "static/media/logo-za-donji-meni.4159fe60.png";